import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import { Account, AccountState } from '@/common/models/Account';
import { UpgradeState } from '../vuex/store';

export default {
  computed: mapState({
    account(state: AppState): Account {
      return state.accountState.account!;
    },
    upgrade(state: AppState): UpgradeState {
      return state.upgradeState;
    },
    accountState(state: AppState): AccountState {
      return state.accountState;
    },
  }),
};
